import useOrderEndpoints from '@/composables/api/useOrderEndpoints';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import { useI18n } from 'vue-i18n';

export default () => {
  const reviveActiveMode = (orderType) => {
    if (orderType) {
      const orderMode = orderType.toUpperCase() === 'BUY' ? 'BUY' : 'SELL';
      const orderStore = useOrderFormStore();
      orderStore.setActiveMode(orderMode);
    }
  };

  const revivePspCode = (paymentData) => {
    if (paymentData.pspCode) {
      const orderStore = useOrderFormStore();
      orderStore.setActiveModePaymentProvider(paymentData.pspCode);
    }
  };

  const reviveLocalStorage = (orderKey) => {
    if (!orderKey) {
      const { t } = useI18n();
      throw new Error(t('PlopenbankForm.error.getOrderId'));
    }
    return new Promise((resolve, reject) => {
      const { getOrderSummary } = useOrderEndpoints();
      getOrderSummary(orderKey)
      .then((response) => {
        const { summary } = response.data.data;
        reviveActiveMode(summary.orderType);

        const paymentData = {
          pspTypeCode: summary.paymentType, // Refer to PSP_TYPE table
          pspCode: summary.paymentCode, // Refer to PSP table
        };
        revivePspCode(paymentData);
        // reviveAvailablePayments(); // In this get payments, await globalStore.fetchPayments();
        resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
    });
  };

  return {
    reviveLocalStorage,
  };
};
